import { createAction } from 'typesafe-actions';

export const jobsActions = {
  setInitialJobs: createAction('user/SET_INITIAL_JOBS')<void>(),
};
